import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import { LoaderComponent } from '@shared/loader/loader.component';


@NgModule({
  declarations: [
    LoaderComponent
  ],
  imports: [
    CommonModule
  ],
  providers: [

  ],
  bootstrap: [],
  exports: [
    LoaderComponent
  ]
})
export class SharedLoaderModule { }
